class DashboardConstants {
    static SUCCESS_ICON_COLOR = "#52c41a";
    static WARNING_ICON_COLOR = "#F04D3E";
}
export default DashboardConstants;
